import { SectionWrapper } from './Section.styled'

const Section = ({ children }) => {
    return (
        <SectionWrapper>{children}</SectionWrapper>
    )
}

export default Section